import MessageBubble from '../MessageBubble';
import { MessageText, WidgetProps } from './index.types';

function HTMLContent({ message, widgetData }: WidgetProps) {
    const { actor, createdAt } = message;
    const { content } = widgetData.parameters as MessageText;

    return (
        <MessageBubble actor={actor} timestamp={createdAt}>
            <div dangerouslySetInnerHTML={{ __html: content }} />
        </MessageBubble>
    );
}

export default HTMLContent;
